import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import {
  selectLoadingReviewDataComplete,
  selectReviewProgressPercentAllDocuments,
  selectTotalReviewedPagesAllDocuments,
  selectTotalReviewPagesAllDocuments,
} from '../../../../store/selectors';

@UntilDestroy()
@Component({
  selector: 'app-analyzing-clause-variance-progress-bar',
  templateUrl: './analyzing-clause-variance-progress-bar.component.html',
  styleUrl: './analyzing-clause-variance-progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyzingClauseVarianceProgressbarComponent implements OnInit {
  public loading: boolean = true;
  public progressPercent: number = 10;
  public totalReviewPagesAllDocuments = 0;
  public totalReviewedPagesAllDocuments = 0;

  constructor(
    private readonly store$: Store,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.store$.select(selectTotalReviewPagesAllDocuments),
      this.store$.select(selectTotalReviewedPagesAllDocuments),
      this.store$.select(selectReviewProgressPercentAllDocuments),
      this.store$.select(selectLoadingReviewDataComplete),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([totalPages, reviewedPages, progressPercent, isComplete]) => {
        this.totalReviewPagesAllDocuments = totalPages;
        this.totalReviewedPagesAllDocuments = reviewedPages;
        this.progressPercent = this.getVisibleProgressPercent(progressPercent);
        this.loading = !isComplete;
        this.cdr.markForCheck();
      });
  }

  private getVisibleProgressPercent(progressPercent: number): number {
    return Math.max(Math.min(progressPercent, 100), 10);
  }
}
